export default __webpack_public_path__ + "static/flowhand-3aa672e2f543f42b72519ab5db0f5d06.png";